module.exports = __webpack_public_path__ + "img/toujours-jaune-doper.4adde3ff.jpg";